import { IDataProviderSort } from 'core-components/types'

export const getArraySort = (
  sort: IDataProviderSort | IDataProviderSort[] | undefined
): IDataProviderSort[] => {
  const notEmptySort = sort || []
  return notEmptySort instanceof Array ? notEmptySort : [notEmptySort]
}
